<script>
import { authComputed, authMethods, optionsComputed } from '@state/helpers'
import Form from '@classes/Form'
import design from '@design'
import { userService } from '@/src/services/UserService'
export default {
  props: {
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    cheight: {
      type: String,
      default: '80vh',
    },
    url: {
      type: String,
      default: null,
    },
    dependentid: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      fileInputKey: 0,
      savedProfilePhoto: '',
      errorMessage: false,
      rules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
      ],
      photoForm: new Form({
        photo: null,
      }),
      profilePicSelected: false,
    }
  },
  computed: {
    ...authComputed,

    ...optionsComputed,
    defaultCaringProfilePhoto() {
      return (
        'https://avatars.dicebear.com/api/initials/' +
        this.firstName +
        '-' +
        this.lastName +
        `.svg?background=${encodeURIComponent(design['global-theme-primary'])}`
      )
    },
  },
  watch: {
    savedProfilePhoto() {
      if (this.savedProfilePhoto === null) {
        this.profilePicSelected = false
      } else {
        this.profilePicSelected = true
      }
    },
  },
  async mounted() {
    try {
      this.updateUserInfo()
    } catch (error) {
      console.warn(error)
    }
  },

  methods: {
    ...authMethods,
    addProfilePic() {
      document.getElementById('profileInputCaring').click()
    },
    updateUserInfo() {
      this.savedProfilePhoto = this.url
    },
    async uploadImage(file) {
      this.errorMessage = false
      if (file) {
        try {
          var obj = {
            photo: file,
            dependent_id: this.dependentid,
          }

          this.photoForm.photo = file
          if (this.photoForm.photo.size < 2000000) {
            const { data } = await userService.uploadImage(obj)
            if (data) {
              const updatedUser = await this.setProfilePicture({
                photo: data,
              })
              if (updatedUser) {
                this.savedProfilePhoto = data
              }
            }
          } else {
            this.errorMessage = true
          }
        } catch (error) {
          console.warn(error)
        }
      }
    },

    async deleteImage() {
      if (this.savedProfilePhoto) {
        try {
          const response = await userService.deleteImage({
            dependent_id: this.dependentid,
          })
          if (response.status === 200) {
            // delete the savedProfilePhoto from the current user
            const updatedUser = await this.removeProfilePicture()
            if (updatedUser) {
              this.savedProfilePhoto = null
              this.fileInputKey++
            }
          }
        } catch (error) {
          console.warn(error)
        }
      }
    },
  },
}
</script>

<template>
  <v-col cols="12" md="12" class="pt-10 pt-sm-0">
    <v-card :class="$style.rounded" outlined class="pa-2">
      <v-card-text>
        <div class="d-flex">
          <div :class="[$style.avartaContainer]">
            <v-avatar small size="120">
              <v-img v-if="savedProfilePhoto" :src="savedProfilePhoto" />
              <v-img v-else :src="defaultCaringProfilePhoto"></v-img>
            </v-avatar>
            <div :class="$style.editIcon" @click="addProfilePic">
              <v-icon>mdi-pencil</v-icon>
            </div>
          </div>
          <div class="flex-grow-1 justify-start">
            <div :class="$style.uploadImageWrapp">
              <div>
                <v-file-input
                  id="profileInputCaring"
                  :key="fileInputKey"
                  :rules="rules"
                  accept="image/png, image/jpeg, image/bmp"
                  hide-input
                  style="display: none"
                  @change="uploadImage"
                >
                  <span>Add Profile Picture</span>
                </v-file-input>
              </div>
              <div :class="$style.linkClss">
                <span :class="$style.profileText"> My Profile Picture </span>
                <div v-if="!profilePicSelected" class="mt-1">
                  <p :class="$style.profileSubText"> Format: JPG or PNG </p>
                  <p :class="$style.profileSubText"> Maximum file size: 2MB </p>
                  <p :class="$style.profileSubText">
                    Ideal size: at least 200x200 pixels
                  </p>
                </div>

                <a v-else class="mt-4" @click="deleteImage">Delete Photo</a>
              </div>
            </div>
          </div>
          <v-row v-if="errorMessage" class="mt-1">
            <v-col cols="12" class="pa-0 ma-0" md="12"
              ><p :class="$style.errorMsg"
                >Failed to upload an image. The image maximum size is 2MB.</p
              ></v-col
            >
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<style lang="scss" module>
@import '@design';

.rounded {
  max-width: 400px;
  border-radius: 5px !important;
}
.avartaContainer {
  position: relative;
  width: 134px;
}
.editIcon {
  position: absolute;
  bottom: -10px;
  left: 45px;
  display: -webkit-inline-box;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
  background-color: #1b3cff;
  border: 2px solid #fff;
  border-radius: 50% !important;
}
.uploadImageWrapp {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 120px;
}
.profileText {
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0.10000000149011612px;
}

.profileSubText {
  margin-bottom: 0 !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  letter-spacing: 0.20000000298023224px;
}
.errorMsg {
  padding: 0 !important;
  margin: 0 !important;
  font-size: 12px;
  color: #f00;
  text-align: center;
}
.linkClss {
  padding: 0 0 0 30px;
}
.linkClss a {
  display: block;
}
@media screen and (max-width: 1440px) {
  .linkClss {
    padding: 0 0 0 30px;
  }
}

@media screen and (max-width: 1280px) {
  .linkClss {
    padding: 0 0 0 23px;
  }
}
</style>

<style scoped>
/deep/ i.v-icon.v-icon {
  color: #fff !important;
}
</style>
